import { useCallback, useEffect, useState } from "react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { Button, Card, Empty, Modal, Popover } from "antd";
import { useNavigate } from "react-router";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useSelector } from "react-redux";
import { modeSelector } from "../../../store/selectors/app.selector";
import SendMoneyService from "../../../services/send-money.service";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { ReactComponent as AddIcon } from "../../../assests/images/Add.svg";
import defaultUser from "../../../assests/images/defaultuser.svg";
import { amountFormat } from "../../../services/common.service";
import profileIcon from "../../../assests/images/profile_large.jpg";
import { useTranslation } from "react-i18next";

export default function DomesticPayeeList() {
  const [noRecords, setNoRecords] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [payeeDetails, setPayeeDetails] = useState({});
  const mode = useSelector(modeSelector);
  const [favType, setFavType] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [payeeImage, setPayeeImage] = useState("");
  const { t } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    setLoader(true);
    getAllPayee("");
  }, []);

  const getPayeeImages = useCallback(async () => {
    try {
      const req = {
        mode: mode,
        accNo: dataSource.map((e) => e.beneAccNo),
      };
      const response = await SendMoneyService.getPayeeImages(req);
      if (response.status === 200) {
        setPayeeImage(response.data["data"]["imagesList"]);
      }
    } catch (error) {}
  }, [dataSource]);

  useEffect(() => {
    if (dataSource.length > 0) {
      getPayeeImages();
    }
  }, [dataSource, getPayeeImages]);

  const getAllPayee = useCallback(async (payee) => {
    try {
      const response = await SendMoneyService.getAllPayee({
        mode: mode,
      });
      if (response.status === 200) {
        setLoader(false);
        setSearchLoader(false);
        const tissbene = response.data["data"]["otherBeneList"].filter(
          (ele) => ele.beneType === "ABC"
        );
        const eftbene = response.data["data"]["otherBeneList"].filter(
          (ele) => ele.beneType === "EFT"
        );

        setDataSource([...tissbene, ...eftbene]);
        setNoRecords([...tissbene, ...eftbene].length > 0 ? false : true);
      }
    } catch (error) {
      setLoader(false);
      setSearchLoader(false);
      setNoRecords(true);
    }
  }, []);

  const addFavouritePayee = useCallback(async (option) => {
    try {
      setFavType(option?.favorites === "N" ? "Y" : "N");
      const response = await SendMoneyService.addFavouritePayee({
        reqId: option?.reqId,
        favorites: option?.favorites === "N" ? "Y" : "N",
        mode: mode,
        beneType: "OTHERBANK",
      });
      if (response.status === 200) {
        // setDataSource([]);
        // getAllPayee();
        setMessage(response.data["message"]);
        setVisible(true);
      }
    } catch (error) {}
  }, []);

  const handleSearch = useCallback((value) => {
    console.log(value);
    setSearchLoader(true);
    getAllPayee(value);
  }, []);

  return (
    <>
      <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
        <Card
          className="transfercard mb-2 application-card"
          align="center"
          onClick={() => navigate("/add-other-beneficary")}
        >
          <div className="mt-2">
            <AddIcon height={30} />
          </div>
          <div className="mt-2">
            <span
              style={{
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              {t("pages.Add_Bene.add_new", {
                defaultValue: "Add New",
              })}
            </span>
          </div>
        </Card>
      </div>
      {dataSource.map((option, idx) => (
        <div
          key={idx}
          className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"
        >
          <Card
            className="transfercard mb-3"
            align="center"
            onClick={() => {
              setEditVisible(true);
              setSelectedOption(option);
              // getPayeeImages(option);
            }}
          >
            <div className="mt-2">
              {payeeImage.length > 0 ? (
                payeeImage.map((image, index) =>
                  image.beneAccNo === option.beneAccNo ? (
                    <img
                      key={index}
                      src={image?.imageData}
                      alt={option.beneNickName}
                      height={30}
                    />
                  ) : null
                )
              ) : (
                <img
                  key="default"
                  src={defaultUser}
                  alt={option.beneNickName}
                  height={30}
                />
              )}
              {payeeImage.length > 0 &&
                !payeeImage.some(
                  (image) => image.beneAccNo === option.beneAccNo
                ) && (
                  <img
                    key="default"
                    src={defaultUser}
                    alt={option.beneNickName}
                    height={30}
                  />
                )}
            </div>
            <div className="mt-2">
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                }}
                className="transfercardspan"
                title={option?.beneNickName || "-"}
              >
                {option.beneNickName || "-"}
              </span>
            </div>
          </Card>
        </div>
      ))}
      {/* <div className="dashboard-accounts-wrapper">
        <div
          className="send-money-container table-body"
          style={{ minHeight: 300, padding: "10px 20px" }}
        >
          <div className="row tbl-column-header">
          <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"> {t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}</div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"> {t("pages.my_accounts.casa.nickname", {
                  defaultValue: "Nick Name",
                })}</div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">{t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}</div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">Account Number</div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">{t("common.bank_name", {
                        defaultValue: "Bank Name",
                      })}</div>
            <div className="col-1">Favourite</div>
            <div className="col-1"></div>
          </div>


          {dataSource.map((option, idx) => (
            <div key={idx} className="row tbl-row-data">
                  <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">{option.beneName || "-"}</div>
              <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                {" "}
                <span
                  className="payee-name"
                  onClick={() =>
                    navigate("/send-money/payee-transfer", {
                      state: { ...option, mode: "PAY_LIST" },
                    })
                  }
                >
                  {option.beneNickName}
                </span>{" "}
              </div>
              <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">{option.beneType === "OTHERBANK"? "Other": "Tips"}</div>
              <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              {option.beneAccNo}
              </div>
              <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">{option.bankName|| "-"}</div>
           
              <div className="col-1" align="center">
                {" "}
                {option.favorites === "Y" && (
                  <AiFillStar
                    onClick={() => addFavouritePayee(option)}
                    className="favourite"
                    style={{ fontSize: 22 }}
                  />
                )}
                {option.favorites === "N" && (
                  <AiOutlineStar
                    onClick={() => addFavouritePayee(option)}
                    className="favourite"
                    style={{ fontSize: 22 }}
                  />
                )}
              </div>
              <div className="col-1" align="center">
                <Popover
                  placement="bottom"
                  content={() => {
                    return (
                      <>
                        <ul className="profile-options">
                          <li
                            onClick={() =>
                              navigate(
                                "/beneficiary-management/domestic-beneficiary-details",
                                {
                                  state: { ...option, type: "VIEW" },
                                }
                              )
                            }
                          >
                            Beneficiary Info
                          </li>
                          <li
                            onClick={() =>
                              navigate(
                                "/beneficiary-management/domestic-beneficiary-modify",
                                {
                                  state: { ...option, type: "MODIFY" },
                                }
                              )
                            }
                            style={{ color: "greeen" }}
                          >
                            {t("pages.Add_Bene.modify_beneficiary", {
                            defaultValue: "Modify Beneficiary",
                          })}
                          </li>
                          <li
                            onClick={() =>
                              navigate(
                                "/beneficiary-management/domestic-beneficiary-details",
                                {
                                  state: { ...option, type: "DELETE" },
                                }
                              )
                            }
                            style={{ color: "red" }}
                          >
                            {t("pages.Add_Bene.delete_deneficiary", {
                defaultValue: "Delete Beneficiary",
              })}
                          </li>
                        </ul>
                      </>
                    );
                  }}
                  trigger="hover"
                >
                  <BsThreeDotsVertical style={{ fontSize: 18 }} />
                </Popover>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <Modal
        open={visible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setVisible(false);
                getAllPayee();
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={editVisible}
        footer={null}
        width={800}
        closable={true}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
        onCancel={() => setEditVisible(false)}
      >
        <div className="row profile-details">
          {/* <div className="col-12 col-sm-12 col-md-6 col-lg-3" align="center">
            {payeeImage !== null && payeeImage?.length > 0 ? (
              <img
                src={payeeImage}
                alt="Profile"
                height={130}
                width={130}
                style={{ backgroundColor: "#108ee9" }}
              />
            ) : (
              <img src={profileIcon} alt="Profile" height={130} />
            )}
          </div> */}
          <div
            className="col-12 col-sm-12 col-md-12 col-lg-12"
            style={{ marginLeft: "20px" }}
          >
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 mt-3">
                <label>
                  {t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}
                </label>
                <span>{selectedOption?.beneName || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 mt-3">
                <label>
                  {t("pages.Add_Bene.bene_nick_name", {
                    defaultValue: "Beneficiary Nick Name",
                  })}
                </label>
                <span>{selectedOption?.beneNickName || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </label>
                <span>{selectedOption?.beneAccNo || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("common.bank_name", {
                    defaultValue: "Bank Name",
                  })}
                </label>
                <span>{selectedOption?.bankName || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("pages.standing_instruction.branch_code", {
                    defaultValue: "Branch Code",
                  })}
                </label>
                <span>{selectedOption?.beneBrn || "-"}</span>
              </div>

              {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>Beneficiary Email</label>
                <span>{selectedOption?.beneEmail || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>Beneficiary Mobile Number</label>
                <span>{selectedOption?.beneMobileNo || "-"}</span>
              </div> */}

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("pages.transfer_limit.transfer_limit", {
                    defaultValue: "Transfer Limit",
                  })}
                </label>
                <span>
                  {amountFormat(
                    selectedOption?.maxTransferLimit,
                    selectedOption?.beneCurrency
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="manage-bene-btn-group">
          <Button
            className="secondary-btn mx-5"
            onClick={() =>
              navigate("/beneficiary-management/domestic-beneficiary-details", {
                state: { ...selectedOption, type: "VIEW" },
              })
            }
            size="large"
          >
            {t("pages.Add_Bene.modify_beneficiary", {
              defaultValue: "Modify Beneficiary",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn mt-2"
            onClick={() =>
              navigate("/send-money/payee-transfer", {
                state: { ...selectedOption, mode: "PAY_LIST" },
              })
            }
            size="large"
          >
            {t("pages.Add_Bene.make_payment", {
              defaultValue: "Make Payment",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
